import { SkeletonBox, SkeletonText } from '../primitives';
import '../primitives/Skeletons.css';

const FeatureRow = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
    <SkeletonBox width={16} height={16} borderRadius="50%" />
    <SkeletonText widths={['80%']} lineHeight="14px" />
  </div>
);

const PlanCardSkeleton = ({ featured = false }) => (
  <div
    style={{
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-md)',
      padding: 'var(--space-xl)',
      borderRadius: 'var(--radius-lg)',
      border: featured
        ? '2px solid var(--color-primary, #059669)'
        : '1px solid var(--color-border)',
      background: 'var(--color-surface)',
      minWidth: '260px',
      boxShadow: featured ? 'var(--shadow-md)' : 'var(--shadow-sm)',
    }}
  >
    {featured && (
      <div
        style={{
          position: 'absolute',
          top: '-12px',
          insetInlineEnd: 'var(--space-md)',
          padding: '4px 12px',
          borderRadius: '999px',
          background: 'var(--color-surface-strong)',
        }}
      >
        <SkeletonText widths={['72px']} lineHeight="14px" />
      </div>
    )}
    <SkeletonText widths={['96px']} lineHeight="20px" />
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--space-xs)' }}>
      <SkeletonText widths={['72px']} lineHeight="36px" />
      <SkeletonText widths={['48px']} lineHeight="14px" />
    </div>
    <SkeletonText widths={['90%', '70%']} lineHeight="14px" />
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)', marginTop: 'var(--space-sm)' }}>
      <FeatureRow />
      <FeatureRow />
      <FeatureRow />
      <FeatureRow />
    </div>
    <SkeletonBox height={44} borderRadius="999px" style={{ marginTop: 'auto' }} />
  </div>
);

const PricingSkeleton = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-2xl)',
      padding: 'clamp(1.5rem, 4vw, 3rem)',
      alignItems: 'center',
    }}
  >
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-md)', alignItems: 'center', textAlign: 'center' }}>
      <SkeletonText widths={['min(440px, 80vw)']} lineHeight="40px" />
      <SkeletonText widths={['min(560px, 70vw)']} lineHeight="18px" />
    </div>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: 'var(--space-lg)',
        width: '100%',
        maxWidth: '960px',
      }}
    >
      <PlanCardSkeleton />
      <PlanCardSkeleton featured />
      <PlanCardSkeleton />
    </div>
  </div>
);

export default PricingSkeleton;
